import { render, staticRenderFns } from "./TextQuestion.vue?vue&type=template&id=2e8d1034&scoped=true"
import script from "./TextQuestion.vue?vue&type=script&lang=js"
export * from "./TextQuestion.vue?vue&type=script&lang=js"
import style0 from "./TextQuestion.vue?vue&type=style&index=0&id=2e8d1034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8d1034",
  null
  
)

export default component.exports